var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotfound = function SvgNotfound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 80 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "inherit",
    height: "inherit",
    x: 0.5,
    fill: "#F8F9FA",
    rx: 40
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#notfound_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    d: "M38.609 21.517h3.78a2.86 2.86 0 0 1 2.76 2.114l2.485 9.226H33.357l2.495-9.226a2.86 2.86 0 0 1 2.757-2.114ZM54.1 56.874H26.9l3.006-11.16h21.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M33.357 32.857h14.275l3.462 12.857H29.906zM22.82 54.731a2.143 2.143 0 0 0 0 4.286h35.36a2.143 2.143 0 1 0 0-4.286z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notfound_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.5 20h40v40h-40z"
  })))));
};
export default SvgNotfound;